export default "assets/images/ca6b77b234b18e7bb9b1ccda774da286.png";